import { useMutation } from "@tanstack/react-query";
import { useCallback } from "react";
import { useAuth0 } from "@auth0/auth0-react";

import {
  PostAcceptedPools,
  PostDeleteAcceptedPools,
} from "../../api/api";

type DeleteAcceptedPoolsResult = {
  status: string;
  notification?: boolean;
};

type DeleteAcceptedPoolsPayload = {
  key: string;
  value: string;
};

export const usePostDeletedAcceptedPools = () => {
  const { getAccessTokenSilently } = useAuth0();

  const mutation = useMutation({
    mutationFn: ({
      key,
      value,
      token,
    }: DeleteAcceptedPoolsPayload & {
      token: string;
    }): Promise<DeleteAcceptedPoolsResult> =>
      PostDeleteAcceptedPools(token, {
        key,
        value,
      }),

    onSuccess: (data) => {
      console.log("data", data);
    },

    onError: (error) => {
      console.error(
        "Error performing miner operations:",
        error
      );
    },
  });

  const mutateWithToken = useCallback(
    async (
      { key, value }: DeleteAcceptedPoolsPayload,
      options?: {
        onSuccess?: (
          data: DeleteAcceptedPoolsResult
        ) => void;
        onError?: (error: any) => void;
        onSettled?: () => void;
      }
    ) => {
      const token = await getAccessTokenSilently();
      console.log();
      mutation.mutate(
        {
          key,
          value,
          token,
        },
        {
          onSuccess: options?.onSuccess,
          onError: options?.onError,
          onSettled: options?.onSettled,
        }
      );
    },
    [getAccessTokenSilently, mutation]
  );

  return { ...mutation, mutate: mutateWithToken };
};
